import { fetchAiCredits } from '~graphql/controllers';
import { handleTabImagesAI } from '~src/sidebar/index';

/**
 * Polls for AI credit changes after an AI operation
 * @param {number} initialCredits - The initial credit balance before the operation
 * @param {Object} options - Configuration options
 * @param {number} options.maxAttempts - Maximum number of polling attempts (default: 3)
 * @param {number} options.pollInterval - Interval between polls in ms (default: 1000)
 * @param {number} options.startDelay - Initial delay before first poll in ms (default: 500)
 */
export default async function pollForCreditChange(
  initialCredits,
  options = {}
) {
  const { maxAttempts = 3, pollInterval = 1000, startDelay = 500 } = options;

  let attempts = 0;

  const poll = async () => {
    attempts++;

    try {
      const creditsData = await fetchAiCredits();
      if (creditsData && creditsData.edges && creditsData.edges[0]) {
        const currentCredits =
          creditsData.edges[0].freeCreditsAmount +
          creditsData.edges[0].paidCreditsAmount;

        // Check if credits changed or we've reached max attempts
        if (currentCredits !== initialCredits || attempts >= maxAttempts) {
          handleTabImagesAI();
          return;
        }
      }
    } catch (error) {
      console.error('Error polling credits:', error);
    }

    // Continue polling if we haven't reached max attempts
    if (attempts < maxAttempts) {
      setTimeout(poll, pollInterval);
    } else {
      // Final refresh even if no change detected
      handleTabImagesAI();
    }
  };

  // Start polling after a short delay to give Lambda time to start
  setTimeout(poll, startDelay);
}
